import React from 'react';
import { Content } from './shared';

const BcbsJennyCraig = () => (
  <Content>
    Enjoy weight loss and nutrition programs at Jenny Craig, plus credits to use toward food through
    the program.
    <ol>
      <li>Visit the Blue365 website and register.</li>

      <li>
        Go to Nutrition {'>'} Jenny Craig {'>'} Go to partner site.
      </li>
    </ol>
  </Content>
);

export default BcbsJennyCraig;
